import {
  Box,
  Button,
  Center,
  Flex,
  Heading,
  Image,
  Text,
} from '@chakra-ui/react';
import axios from 'axios';
import { useEffect, useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { Link, useParams } from 'react-router-dom';
import Landscape from './landscape.jpg';

const BookDetails = () => {
  const { movieId } = useParams();
  const [movie, setMovie] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    const getMovie = async () => {
      const response = await axios.post(
        `https://mern-stack-movies-app.herokuapp.com/movies/search`,
        {
          movieId,
        }
      );
      setMovie(response.data);
      setSearchTerm(response.data.genres[0]);
    };
    getMovie();
  }, [movie, movieId]);

  useEffect(() => {
    const getSuggestions = async () => {
      const notify = () =>
        toast.loading(
          'Loading suggestions. This might take up to 10s (or more).',
          {
            duration: 10000,
            id: 'loading toast',
          }
        );
      notify();
      const response = await axios.post(
        `https://mern-stack-movies-app.herokuapp.com/movies/search/genre`,
        {
          searchTerm,
        }
      );
      setSuggestions(
        response.data.sort(() => 0.5 - Math.random()).slice(0, 21)
      );
    };
    getSuggestions();
  }, [searchTerm]);

  return (
    <>
      <Toaster />
      <Center>
        <Flex
          key={movieId}
          direction="column"
          align="center"
          justify="center"
          textAlign="center"
          w="600px"
          border="2px solid #000"
          mt={7}
          mb={10}
          pb={5}
          bg="#e8ecf1"
          overflow="hidden"
        >
          <Image
            alt={`Movie poster`}
            src={
              movie.poster === undefined ? `${Landscape}` : `${movie.poster}`
            }
            pb={5}
            transition="transform 0.5s ease"
            _hover={{
              transform: 'translateY(80px) scale(2.0)',
            }}
          />
          <Box pb={5} pl={5} pr={5}>
            <Text fontSize="lg" fontWeight="700" as="u" color="#ff0000">
              Title
            </Text>
            <Text fontSize="lg" color="#000" mt={2} mb={2}>
              {movie.title ? movie.title : 'No title found'}
            </Text>
            <Text fontSize="lg" fontWeight="700" as="u" color="#ff0000">
              Cast
            </Text>
            <Text fontSize="lg" color="#000" mt={2} mb={2}>
              {movie.cast ? (
                movie.cast.map((actor, index) => (
                  <p
                    key={index}
                    css={{
                      display: 'inline',
                    }}
                  >
                    {' '}
                    {actor}
                    {index < movie.cast.length - 1 ? ',\u00A0' : ''}
                  </p>
                ))
              ) : (
                <p>No actors found</p>
              )}
            </Text>
            <Text fontSize="lg" fontWeight="700" as="u" color="#ff0000">
              Director(s)
            </Text>
            <Text fontSize="lg" color="#000" mt={2} mb={2}>
              {movie.directors ? (
                movie.directors.map((director, index) => (
                  <p
                    key={index}
                    css={{
                      display: 'inline',
                    }}
                  >
                    {' '}
                    {director}
                    {index < movie.directors.length - 1 ? ',\u00A0' : ''}
                  </p>
                ))
              ) : (
                <p>No directors found</p>
              )}
            </Text>
            <Text fontSize="lg" fontWeight="700" as="u" color="#ff0000">
              Plot
            </Text>
            <Text fontSize="lg" color="#000" mt={2} mb={2}>
              {movie.fullplot ? movie.fullplot : 'No plot found'}
            </Text>
            <Text fontSize="lg" fontWeight="700" as="u" color="#ff0000">
              Genres
            </Text>
            <Text fontSize="lg" color="#000" mt={2} mb={2}>
              {movie.genres ? (
                movie.genres.map((genre, index) => (
                  <p
                    key={index}
                    css={{
                      display: 'inline',
                    }}
                  >
                    {' '}
                    {genre}
                    {index < movie.genres.length - 1 ? ',\u00A0' : ''}
                  </p>
                ))
              ) : (
                <p>No genres found</p>
              )}
            </Text>
            <Text fontSize="lg" fontWeight="700" as="u" color="#ff0000">
              Countries
            </Text>
            <Text fontSize="lg" color="#000" mt={2} mb={2}>
              {movie.countries ? (
                movie.countries.map((country, index) => (
                  <p
                    key={index}
                    css={{
                      display: 'inline',
                    }}
                  >
                    {' '}
                    {country}
                    {index < movie.countries.length - 1 ? ',\u00A0' : ''}
                  </p>
                ))
              ) : (
                <p>No countries found</p>
              )}
            </Text>
            <Text fontSize="lg" fontWeight="700" as="u" color="#ff0000">
              Year
            </Text>
            <Text fontSize="lg" color="#000" mt={2} mb={2}>
              {movie.year ? movie.year : 'No year found'}
            </Text>
          </Box>
        </Flex>
      </Center>
      <Center as="u" mb={5}>
        <Heading>SUGGESTIONS</Heading>
      </Center>
      <Box mb={10}>
        <Flex direction="row" wrap="wrap" justify="center">
          {suggestions ? (
            suggestions.map((suggestion, index) => {
              return (
                <Flex
                  key={index}
                  direction="column"
                  align="center"
                  justify="center"
                  textAlign="center"
                  w="300px"
                  border="2px solid #000"
                  mt={10}
                  mx={5}
                  bg="#e8ecf1"
                  overflow="hidden"
                >
                  <Image
                    alt=""
                    src={
                      suggestion.poster === undefined
                        ? `${Landscape}`
                        : `${suggestion.poster}`
                    }
                    transition="transform 0.5s ease"
                    _hover={{
                      transform: 'translateY(80px) scale(2.0)',
                    }}
                    pt={0}
                    pb={5}
                  />
                  <Box pb={5} pl={5} pr={5}>
                    <Text fontSize="lg" fontWeight="700" as="u" color="#ff0000">
                      Title
                    </Text>
                    <Text fontSize="lg" color="#000" mt={2} mb={2}>
                      {suggestion.title}
                    </Text>
                    <Text fontSize="lg" fontWeight="700" as="u" color="#ff0000">
                      Genres
                    </Text>
                    <Text fontSize="lg" color="#000" mt={2} mb={2}>
                      {suggestion.genres ? (
                        suggestion.genres.map((genre, index) => (
                          <p
                            key={index}
                            css={{
                              display: 'inline',
                            }}
                          >
                            {' '}
                            {genre}
                            {index < movie.genres.length - 1 ? ',\u00A0' : ''}
                          </p>
                        ))
                      ) : (
                        <p>No genres found</p>
                      )}
                    </Text>
                    <Link to={'/movie/' + suggestion._id}>
                      <Button
                        bg="#f9bf3b"
                        _hover={{
                          background: '#ff0000',
                          color: '#fff',
                        }}
                      >
                        Show info
                      </Button>
                    </Link>
                  </Box>
                </Flex>
              );
            })
          ) : (
            <Box className="alert">
              <Text fontWeight="700">No suggestions found</Text>
            </Box>
          )}
        </Flex>
      </Box>
    </>
  );
};

export default BookDetails;
